import MintChocolate from '../assets/mintChocolate.jpg';
import BlueberryCocoa from '../assets/blueberryCocoa.jpg';
import Cherry from '../assets/cherry.jpg';
import FerreroNuts from '../assets/ferreroNuts.jpg';
import RedVelvet from '../assets/redVelvet.jpg';
import Lemon from '../assets/lemon.jpg';

export const MenuList = [
  {
    id: "1",
    name: "Mint Chocolate Cupcake",
    image: MintChocolate,
    price: 4.99
  },
  {
    id: "2",
    name: "Blueberry Cocoa Cupcake",
    image: BlueberryCocoa,
    price: 3.99,
  },
  {
    id: "3",
    name: "Cherry Cupcake",
    image: Cherry,
    price: 3.99,
  },
  {
    id: "4",
    name: "Ferrero Nuts Cupcake",
    image: FerreroNuts,
    price: 5.99,
  },
  {
    id: "5",
    name: "Red Velvet Cupcake",
    image: RedVelvet,
    price: 4.99,
  },
  {
    id: "6",
    name: "Lemon Cupcake",
    image: Lemon,
    price: 4.99,
  }
]
